module.exports = __webpack_public_path__ + "media/images/plus-4133a954.svg";